import React, { Component } from 'react'
import { RoomContext } from '../context'
import Loading from './loading'
import Room from './room'
import Title from './title'
export default class FeaturedRooms extends Component {
    static contextType = RoomContext
    render() {
        let {loading, featuredRooms: rooms} = this.context
        // console.log(rooms)
        rooms = rooms.map(room => {
            return <Room key={room.id} room={room}/>
        })
        return (
            <section className='featured-rooms'>
               <Title title='Our Featured Rooms'/>
               <div className='featured-rooms-center'>
                    {loading ? <Loading/> : rooms }
               </div>
            </section>
        ) 
    }
}
